// extracted by mini-css-extract-plugin
export default {"container":"TogglableTags_container__VcsQc"};